import { sanitizePhoneNumber } from "core/strings";
import { create } from "zustand";


export const useStoreAuth = create((set, get) => ({
	country: "+1",
	phone: "",
	email: "",
	token: "",
	type: "email",
	device: null,
	code: "",
	check: false,

	setPhone: (v) => set(() => ({ phone: v })),
	setEmail: (v) => set(() => ({ email: v })),
	resetAccount: () => set(() => ({ phone: "", email: "" })),

	setCode: (v) => set(() => ({ code: v })),
	setToken: (v) => set(() => ({ token: v })),
	setDevice: (v) => set(() => ({ device: v }) ),

	toggleCheck: () => set(($) => ({ check: !$.check })),

	toggleType: () => set(($) => {
		$.resetAccount();
		return { type: $.type === "email" ? "phone" : "email" };
	}),
	setToPhone: (v) => set(() => ({ type: "phone", phone: v })),
	setToEmail: (v) => set(() => ({ type: "email", email: v })),
	isEmail: () => get().type === "email",

	sanitizePhone: (v) => {
		const phone = !v.startsWith("+") ? `+1${v}` : v;
		return sanitizePhoneNumber(phone);
	},
	fillAccount: () => {
		const store = get();
		const body = {};

		if (store.isEmail()) body.email = store.email;
		else {
			const phone = !store.phone.startsWith("+") ? `${store.country}${store.phone}` : store.phone;
			body.phone = sanitizePhoneNumber(phone);
		};
		return body;
	}
}));